import {
    IChannelCategory,
    IChannelData,
    IChannelInfo,
    IChannelPacket,
    ResponseDto,
} from '@r1-frontend/api-domru/api-profile/v2/tv-packets/index';

type TFormattedChannelData = Omit<IChannelData, 'channels'>  & {
    channels: {
        channelId: number,
        internalId: number,
        title: string,
        alias: string,
        categoryId: number,
        analog: number,
        catchupAvailable: number,
        digital: number,
        encryption: boolean,
        frequency: number,
        providerId: number,
        quality: string,
        lcn: number,
        category: IChannelCategory,
        channelInfo: IChannelInfo,
        packets: IChannelPacket[],

        button: string,
        epgId: string,
        chid: number,
        biglogo: string,
        description: string,
        display: boolean,
        hd: '1' | '0',
        url?: string,
        logo?: string,
        theme: IChannelCategory & {
            thid: number,
        },
        thid: number,
    }[],
}

export const channelFormatterForEpg = ({ channels, ...rest }: IChannelData): TFormattedChannelData => {
    return {
        ...rest,
        channels: channels.map(channel => ({
            ...channel,
            button: `№ кнопки ${channel.lcn}`,
            logo: channel.channelInfo?.logo,
            chid: channel.channelId,
            xvid: channel.epgId,
            biglogo: channel?.channelInfo.bigLogo,
            description: channel?.channelInfo.description,
            display: channel?.channelInfo.display,
            hd: channel.quality === 'HD' ? '1' : '0',
            title: channel.title,
            url: channel?.channelInfo?.url,
            theme: {
                ...channel.category,
                thid: channel.category.rndId,
            },
            thid: channel.category.rndId,
        })),
    };
};


export const formatterEpg = (data: ResponseDto)=> {
    return  {
        ...data,
        canConnect: data.canConnect.map(connectElement => channelFormatterForEpg(connectElement)),
        connectedInTariff: data.connectedInTariff.map(connectedInTariffElement =>  channelFormatterForEpg(connectedInTariffElement)),
        connectedOutTariff: data.connectedOutTariff.map(connectedOutTariffElement => channelFormatterForEpg(connectedOutTariffElement)),
    };
};
